const Api = {
    prod:"https://us-central1-sheq-986ac.cloudfunctions.net/api/",
    stage:"https://us-central1-sheq-wallet-34fde.cloudfunctions.net/api/",
    local:"/"
}

Api.endpoint = Api.stage;

export default Api;